import { Container } from "@mui/material";

const PektaHeader = ({ page }) => {
  return (
    <Container maxWidth={false} disableGutters>
      <div className="bg-gray-800 sm:h-44 m-auto w-screen">
        <div className="flex flex-col sm:mx-24 p-4">
          <h1 className="text-white text-2xl pb-4">
            Permohonan Pengkursus Ibadat Haji Tanah Air (PEKTA)
          </h1>
          <div className="flex space-x-5">
            <div>
              <div
                className={`h-1 w-auto ${
                  page >= 1 ? "bg-green-600" : "bg-white"
                } ml-auto mt-auto`}
              ></div>
              <br />
              <p className="text-white ml-auto text-sm">Maklumat Diri Anda</p>
              <p className="text-sm text-gray-400 ml-auto hidden md:block">
                Pastikan nama dan informasi adalah tepat
              </p>
            </div>

            <div>
              <div
                className={`h-1 w-auto ${
                  page >= 2 ? "bg-green-600" : "bg-white"
                } ml-auto mt-auto`}
              ></div>
              <br />
              <p className="text-white ml-auto text-sm">Kelulusan Akademik</p>
              <p className="text-sm text-gray-400 ml-auto hidden md:block">
                Pastikan nama dan informasi adalah tepat
              </p>
            </div>

            <div>
              <div
                className={`h-1 w-auto ${
                  page >= 3 ? "bg-green-600" : "bg-white"
                }  ml-auto mt-auto`}
              ></div>
              <br />
              <p className="text-white ml-auto text-sm">Muat Naik Dokumen</p>
              <p className="text-sm text-gray-400 ml-auto hidden md:block">
                Pastikan nama dan informasi adalah tepat
              </p>
            </div>

            <div>
              <div
                className={`h-1 w-auto ${
                  page >= 4 ? "bg-green-600" : "bg-white"
                }  ml-auto mt-auto`}
              ></div>
              <br />
              <p className="text-white ml-auto text-sm">Pengakuan</p>
              <p className="text-sm text-gray-400 ml-auto hidden md:block">
                Pastikan nama dan informasi adalah tepat
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PektaHeader;
